import BaseHandler from "../BaseHandler";
import { UserContactsDelete } from "../../proto/UserContactsDelete_pb";
import store from "../../store";
import { deleteUserContacts } from "../../store/users/actions";

export default class HandleUserContactsDeleteResponse extends BaseHandler<UserContactsDelete> {
  handle() {
    const deleteUserContactResponse = this.response.toObject();
    const memberId = Object.values(store.getState().users.users).find((user) => user.phone === deleteUserContactResponse.phone);
    if (memberId !== undefined) {
      store.dispatch(deleteUserContacts(memberId?.id));
    }
  }
}
